import React, { useEffect, useState } from 'react'

import {
  IconButton,
  Typography,
  TextField,
  Autocomplete,
  Collapse
} from '@mui/material'
import NorthIcon from '@mui/icons-material/North'
import SouthIcon from '@mui/icons-material/South'
import FilterAltIcon from '@mui/icons-material/FilterAlt'
import FilterAltOffIcon from '@mui/icons-material/FilterAltOff'
import classNames from 'classnames'

import styles from './ProductsHeader.module.css'

function ProductsHeader({
  setOrderByParam,
  setFilterByParam,
  categoriesOptions
}) {
  const [orderBy, setOrderBy] = useState({ criteria: 'name', order: false })
  const [filterBy, setFilterBy] = useState({
    criteria: 'category',
    selected: null
  })
  const [showFilters, setShowFilters] = useState(false)

  const handleClickNameFilter = () => {
    handleSortChange('name')
  }

  const handleClickCategoryFilter = () => {
    handleSortChange('category')
  }

  const handleClickPriceFilter = () => {
    handleSortChange('price')
  }

  const handleSortChange = (criteria) => {
    setOrderBy((prevState) => ({
      criteria,
      order: criteria === prevState.criteria ? !prevState.order : false
    }))
  }

  const handleFilterChange = (event, filterValue) => {
    setFilterBy(() => ({
      criteria: 'category',
      selected: filterValue
    }))
  }

  const toggleShowFilters = () => {
    setShowFilters(!showFilters)
  }

  useEffect(() => {
    setOrderByParam(orderBy)
    setFilterByParam(filterBy)
  }, [orderBy, filterBy])

  return (
    <div className={styles.productsHeaderContainer}>
      <div className={styles.productsHeader}>
        <IconButton
          onClick={() => handleClickNameFilter()}
          className={classNames(styles.nameButton, [
            orderBy.criteria === 'name' && styles.lastPressed
          ])}
        >
          {orderBy.criteria === 'name' &&
            (orderBy.order ? (
              <NorthIcon fontSize="small" className={styles.icon} />
            ) : (
              <SouthIcon fontSize="small" className={styles.icon} />
            ))}
          <Typography className={styles.text}>Name</Typography>
        </IconButton>
        <IconButton
          onClick={() => handleClickCategoryFilter()}
          className={classNames(styles.categoryButton, [
            orderBy.criteria === 'category' && styles.lastPressed
          ])}
        >
          {orderBy.criteria === 'category' &&
            (orderBy.order ? (
              <NorthIcon fontSize="small" className={styles.icon} />
            ) : (
              <SouthIcon fontSize="small" className={styles.icon} />
            ))}
          <Typography className={styles.text}>Category</Typography>
        </IconButton>
        <IconButton
          onClick={() => handleClickPriceFilter()}
          className={classNames(styles.priceButton, [
            orderBy.criteria === 'price' && styles.lastPressed
          ])}
        >
          {orderBy.criteria === 'price' &&
            (orderBy.order ? (
              <NorthIcon fontSize="small" className={styles.icon} />
            ) : (
              <SouthIcon fontSize="small" className={styles.icon} />
            ))}
          <Typography className={styles.text}>Price</Typography>
        </IconButton>
        <IconButton
          onClick={() => toggleShowFilters()}
          className={styles.filterButton}
        >
          {showFilters ? (
            <FilterAltOffIcon fontSize="small" className={styles.icon} />
          ) : (
            <FilterAltIcon fontSize="small" className={styles.icon} />
          )}
        </IconButton>
      </div>
      <Collapse in={showFilters}>
        <div className={styles.filtersContainer}>
          <Autocomplete
            className={styles.autocomplete}
            options={categoriesOptions}
            onChange={handleFilterChange}
            renderInput={(params) => (
              <TextField {...params} label="Filter by category" />
            )}
          />
        </div>
      </Collapse>
    </div>
  )
}

export default ProductsHeader
